import React, {useEffect} from 'react'
import Iframe from 'react-iframe'
import Documentation from 'pages/documentation'

function Support() {

    // useEffect(() => {

    //     const script = document.createElement('script');

    //     window.fwSettings = {
    //         'widget_id':60000003162
    //     }
    //     script.type = "text/javascript"
    //     script.src = "https://widget.freshworks.com/widgets/60000003162.js";
    //     script.async = true;
    //     script.defer = true;


    //     document.body.appendChild(script);

    //     return () => {
    //         document.body.removeChild(script);
    //     }
    // //     <script>
    // //     window.fwSettings={
    // //     'widget_id':60000003162
    // //     };
    // //     !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}() 
    // // </script>
    // // <script type='text/javascript' src='https://widget.freshworks.com/widgets/60000003162.js' async defer></script>
    // })

    return (
        <div className="container my-5">
            <h1 id="zoom-integration-documentation">Support</h1>
                &nbsp;&nbsp;
            <h2 id="email-support">Email Support</h2>
            <p>If you would like to contact us by email, you can submit a support ticket <a target="_blank" href="mailto:hello@sutra.fit">here</a>. You can expect to receive a response from our team within 24 hours of submitting a request if submitted during the hours below:
            ‍</p>
            <h3 id="email-support-hours-pacific-time-">Email Support Hours (Pacific Time)</h3>
            <ul>
            <li>Monday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Tuesday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Wednesday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Thursday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Friday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Saturday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Sunday: 8:00 a.m. - 5:00 p.m.</li>
            </ul>
            <h2 id="phone-support">Phone Support</h2>
            <p>If you would like to contact us via phone you can reach us at: (617) 447 - 5835. If you reach out to our team outside of the hours stated below, you can expect a response by the next opening hours.
            ‍</p>
            <h3 id="phone-support-hours-pacific-time-">Phone Support Hours (Pacific Time)</h3>
            <ul>
            <li>Monday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Tuesday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Wednesday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Thursday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Friday: 8:00 a.m. - 5:00 p.m.</li>
            <li>Saturday: Not available</li>
            <li>Sunday: Not available</li>
            </ul>


            <Iframe
            url="https://sutrahelp.freshdesk.com/support/home"
            width="100%"
            height="1000px"
             />

            <Documentation />
            
        </div>
    )
}

export default Support